// ** Initial user ability
export const initialAbility = [
  {
    action: 'read',
    subject: 'home'
  }
]

export const _ = undefined
